import { linkpassDelete } from '../../utils/fetch';

/*
 * DELETE /pex/me/exchange-linkages/:exchangeId replaces the legacy invalidate call, which
 * was keyed on accessId and partnerIdentity - neither of which a Linkpass session issues.
 * The AsiaMiles second hop does not apply: there is no partner redirect in the response.
 */
const unlinkAccount = (exchangeId) => async (e) => {
  const btn = e.target;
  btn.disabled = true;
  btn.classList.add('loading');

  try {
    await linkpassDelete(`/pex/me/exchange-linkages/${exchangeId}`);
    window.location.reload();
  } catch (err) {
    // this button has no error surface of its own; at least let the member retry
    btn.disabled = false;
    btn.classList.remove('loading');
  }
};

export default unlinkAccount;
